/**
 * Created by Allan on 2022/08/05.
 * Contact 84880528@qq.com.
 * 订单中心
 */
export default[
    //订单首页
    {
        path:'/app/order/index',
        name:'order',
        meta:{
            title:'Detalles del pedido',
        },
        component: resolve => require(['@/repayment/views/order/index/index.vue'], resolve)
    },
    //展期订单
    {
        path:'/app/order/delayed/:orderId',
        name:'orderDelayed',
        meta:{
            title:'Extensión de pago'
        },
        component:()=>import('@/repayment/views/order/delayed/index')
    },
    //历史订单列表
    {
        path:'/app/order/history/list',
        name:'orderHistory',
        meta:{
            title:'Pedido histórico',
        },
        component: resolve => require(['@/repayment/views/order/history/index.vue'], resolve)
    },
    //订单详情
    {
        path:'/app/order/history/list/details/:orderId',
        name:'orderDetails',
        meta:{
            title:'Detalles del pedido',
        },
        component: resolve => require(['@/repayment/views/order/loanOrder/index.vue'], resolve)
    },
    //SPE支付页面
    {
        path:'/app/order/history/details/payment/spe/index',
        name:'orderSpe',
        meta:{
            title:'SPEI Reembolso',
        },
        component: resolve => require(['@/repayment/views/order/spei/index.vue'], resolve)
    },
    //OXXO支付页面
    {
        path:'/app/order/history/details/payment/oxxo/index',
        name:'orderOxxo',
        meta:{
            title:'OXXO | PAY',
        },
        component: resolve => require(['@/repayment/views/order/oxxo/index.vue'], resolve)
    },
    //完成订单
    {
        path:'/app/order/history/details/:orderId/:loanTenureType/:curInstallment',
        name:'orderResult',
        meta:{
            title:'Detalles del pedido',
        },
        component: resolve => require(['@/repayment/views/order/details/index.vue'], resolve)
    },
    //严厉打击恶意欠款行为
    {
        path:'/app/order/debtbehavior',
        name:'debtbehavior',
        meta:{
            title:''
        },
        component:()=>import('@/repayment/views/order/debtbehavior/index')
    },
]



// WEBPACK FOOTER //
// ./src/repayment/router/map/order.js